export default "__VITE_ASSET__BPWz5pK___"